<template>
  <b-form @submit.prevent="$emit('processCategoria', categoria)">
    <!-- Categoría Info: Input Fields -->
    <b-form>
      <b-row>

        <!-- Field: Nombre -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Nombre"
            label-for="nombre"
          >
            <b-form-input
              id="nombre"
              v-model="categoria.nombre"
              :state="!$v.categoria.nombre.$invalid"
              placeholder="Introduce el nombre"
              @input="$v.categoria.$touch"
            />
            <b-form-invalid-feedback
              v-if="$v.categoria.$dirty"
              id="nombreInfo"
            >
              El campo nombre
              <span v-if="!$v.categoria.nombre.required"> es requerido.</span>
              <span v-if="!$v.categoria.nombre.maxLength"> debe tener max 150 caracteres.</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <!-- Field: Estado -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Estado"
            label-for="estado"
          >
            <b-form-select
              v-model="categoria.estado"
              placeholder="Selecciona un estado"
              :state="!$v.categoria.estado.$invalid"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="estadoOptions"
              :reduce="val => val.value"
              :clearable="false"
              input-id="estado"
              @input="$v.categoria.$touch"
            />
            <b-form-invalid-feedback
              v-if="$v.categoria.$dirty"
              id="estadoInfo"
            >
              El campo estado
              <span v-if="!$v.categoria.estado.required"> es requerido.</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

      </b-row>
    </b-form>
    <!-- Action Buttons -->
    <btnSubmit
      :btnDisabled="$v.categoria.$invalid"
      :btnText="categoriaSubmit"
    />
  </b-form>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BFormInvalidFeedback, BFormSelect,
} from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import {
  required, maxLength,
} from 'vuelidate/lib/validators'

const btnSubmit = () => import('@/layouts/components/Recycled/Form/btnSubmit.vue')

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BForm,
    BFormInvalidFeedback,
    // vSelect,
    btnSubmit,
  },
  mixins: [validationMixin],
  props: {
    categoria: {
      type: Object,
      required: true,
    },
    categoriaSubmit: {
      type: String, // Texto del boton
      default: 'Guardar Categoría',
    },
  },
  validations: {
    categoria: {
      nombre: {
        required,
        maxLength: maxLength(150),
      },
      estado: {
        required,
      },
    },
  },
  setup() {
    const estadoOptions = [
      { value: null, text: 'Selecciona un estado' },
      { value: 'Activo', text: 'Activo' },
      { value: 'Inactivo', text: 'Inactivo' },
    ]

    return {
      estadoOptions,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
